/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 5.0.12
* 
*******************************************************************************/"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.NOOP=exports.updateLayoutMap=exports.updatePrefix=void 0;/**
 * Prefix is for iterable children in setting navigation ids. This helper function will generate
 * unique prefix and cache in component. As navigation id has to be unique within the application.
 *
 * @param {Object} scope Scope to trigger the function
 * @returns {String} prefix
 */var updatePrefix=function(a){var b=a.prefix;return a.props&&a.props.prefix&&(b=a.props.prefix),b||(b=Date.now().toString(36)),a.prefix=b,b};exports.updatePrefix=updatePrefix;var updateLayoutMap=function(a,b,c){var d=a.layoutMap;if(a.props&&a.props.layoutMap&&(d=a.props.layoutMap),!d){var e=updatePrefix(a);d="";for(var f=0,g=b.length;f<g;f+=1)d+=e+f+((f+1)%c?"  ":"\n")}return a.layoutMap=d,d};exports.updateLayoutMap=updateLayoutMap;var NOOP=function(){};exports.NOOP=NOOP;